export default __webpack_public_path__ + "325d4a8193985860c3f7009e776138ae.png";